"use client"

export default function RouteLoading() {
  return (
    <div className="min-h-screen w-full bg-white dark:bg-gray-950 text-gray-900 dark:text-white flex flex-col items-center justify-center gap-8 transition-colors duration-300">
      <div className="relative">
        <div className="w-20 h-20 rounded-full border-4 border-blue-500/10 dark:border-blue-500/20" />
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-600 dark:border-t-blue-500 animate-spin" />
      </div>
      <div className="flex flex-col items-center gap-2 text-center">
        <p className="text-lg font-semibold">正在加载页面</p>
        <p className="text-sm text-gray-500 dark:text-gray-400">请稍候，我们正在准备最新内容…</p>
      </div>
    </div>
  )
}
